<!--
    @name: 搜索结果
    @description: 重构搜索页
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-08-26 16:22:09
-->
<template>
  <div>
    <div class="searchResult">
      <div class="tableTitle">
        <div
          class="right"
          :class="index == 0 ? 'OnAction' : 'unAction'"
          @click="index = 0"
          style="margin-left: 10px"
        >
          <span
            >工程工队<span>(&nbsp;{{ count0 }}&nbsp;)</span></span
          >
        </div>
        <div class="light"></div>
        <div
          class="right"
          :class="index == 1 ? 'OnAction' : 'unAction'"
          @click="index = 1"
        >
          <span
            >专业工人<span>(&nbsp;{{ count1 }}&nbsp;)</span></span
          >
        </div>
        <div class="light"></div>

        <div
          class="right"
          :class="index == 2 ? 'OnAction' : 'unAction'"
          @click="index = 2"
        >
          <span
            >工种报价<span>(&nbsp;{{ count2 }}&nbsp;)</span></span
          >
        </div>
        <div class="light"></div>
        <div
          class="right"
          :class="index == 3 ? 'OnAction' : 'unAction'"
          @click="index = 3"
        >
          <span
            >劳务用工<span>(&nbsp;{{ count3 }}&nbsp;)</span></span
          >
        </div>
        <div class="light"></div>
        <div
          class="right"
          :class="index == 4 ? 'OnAction' : 'unAction'"
          @click="index = 4"
        >
          <span
            >临时用工<span>(&nbsp;{{ count4 }}&nbsp;)</span></span
          >
        </div>
        <div class="light"></div>

        <div
          class="right"
          :class="index == 5 ? 'OnAction' : 'unAction'"
          @click="index = 5"
        >
          <span
            >工程公司<span>(&nbsp;{{ count5 }}&nbsp;)</span></span
          >
        </div>
        <div class="light"></div>
        <div
          class="right"
          :class="index == 6 ? 'OnAction' : 'unAction'"
          @click="index = 6"
        >
          <span>班组找活<span>(&nbsp;{{ count6 }}&nbsp;)</span></span>
        </div>
      </div>
      <!-- <ul>
        <li @click="index = 0" :class="{ color02: index == 0 }">
          <div class="rent-title">工程工队</div>
        </li>
        <li @click="index = 1" :class="{ color02: index == 1 }">
          <div class="rent-title">专业工人</div>
        </li>
        <li @click="index = 2" :class="{ color02: index == 2 }">
          <div class="rent-title">工种报价</div>
        </li>
        <li @click="index = 3" :class="{ color02: index == 3 }">
          <div class="rent-title">劳务用工</div>
        </li>
        <li @click="index = 4" :class="{ color02: index == 4 }">
          <div class="rent-title">临时用工</div>
        </li>
        <li @click="index = 5" :class="{ color02: index == 5 }">
          <div class="rent-title">工程公司</div>
        </li>
      </ul> -->
    </div>
    <!-- 工程工队 -->
    <team ref="team" v-if="index == 0"></team>
    <!-- 专业工人 -->
    <work v-if="index == 1"></work>
    <!-- 工种报价 -->
    <teamPrice v-if="index == 2"></teamPrice>
    <!-- 劳务用工 -->
    <labor v-if="index == 3"></labor>
    <!-- 临时用工 -->
    <employment v-if="index == 4"></employment>
    <!-- 工程公司 -->
    <engineeringCompany v-if="index == 5"></engineeringCompany>
    <!-- 班组找活 -->
    <teamJob v-if="index == 6"></teamJob>
  </div>
</template>
<script>
import { apiResignAll } from "@/api/apiResignAll"
import cookie from "@/storage/cookies.js"
export default {
  name: "SearchResult",
  data() {
    return {
      index: 0,
        count0: 0,
        count1: 0,
        count2: 0,
        count3: 0,
        count4: 0,
        count5: 0,
        count6: 0,
      params: {},
      param: {
        page: 1,
        limit: 40,
        total: 0
      }
    }
  },
  mounted() {
    this.getPageTotal()
  },
  methods: {
    //获取几个页面总数据
    async getPageTotal() {
      let area = JSON.parse(cookie.cookieRead("area"))
      let params = { ...this.params }
      params.current = this.param.page
      params.limit = this.param.limit
      //获取搜索值
      params.keyword = localStorage.getItem("search_query")
      //省份ID
      // params.provinceNo = area.id
      params.provinceNo = area
        ? area.id
        : this.$refs.team.$children[0].$refs.locationAddress.provinceId
      this.list = []
      let { data } = await apiResignAll.getHomePageTotal(params)
      if (data.code == 200) {
        let count = data.data.map(v => {
          return v.num
        })
        this.count0 = count[0]
        this.count1 = count[1]
        this.count2 = count[2]
        this.count3 = count[3]
        this.count4 = count[4]
        this.count5 = count[5]
        this.count6 = count[6]
      }
    }
  },
  computed: {},
  components: {
    team: () => import("./page/team"), // 工程工队
    work: () => import("./page/work"), // 专业工人
    teamPrice: () => import("./page/teamPrice"), // 工种报价
    labor: () => import("./page/labor"), // 劳务用工
    employment: () => import("./page/employment"), // 临时用工
    engineeringCompany: () => import("./page/engineeringCompany"), //工程公司
    teamJob: () => import("./page/teamJob") //班组找活
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
.searchResult {
  width: 1200px;
  margin: 10px auto 0px;
  overflow: hidden;
  .tableTitle {
    width: 1198px;
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: #fff;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    .light {
      margin: 0 10px;
      width: 1px;
      height: 24px;
      background: rgba(228, 231, 237, 1);
    }

    .right {
      padding: 0px 20px;
      // width: 110px;
      height: 40px;
      text-align: center;
      line-height: 40px;
    }

    .OnAction {
      span {
        color: #e1251b;
        border-bottom: 2px solid #e1251b;
        font-weight: bold;
        display: inline-block;
        height: 38px;
      }
    }
    .unAction {
      border-bottom: none;
    }
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    overflow: hidden;
    li {
      width: 140px;
      line-height: 45px;
      float: left;
      text-align: center;
      background-color: #ffffff;
      cursor: pointer;
      border: 1px solid #e4e7ed;
      &:last-child {
        border-left: none;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }
    .color02 {
      color: #e1251b;
      font-weight: bold;
      background-color: #f5f7fa;
    }
  }
}
</style>
